import { ShieldCheck, Clock, Award, Users, FileCheck, HardHat } from "lucide-react";

const FEATURES = [
  {
    icon: ShieldCheck,
    title: "Licensed & Fully Insured",
    desc: "WSIB covered, $2M liability, licensed trades on every project across the GTA.",
  },
  {
    icon: FileCheck,
    title: "Permit-Compliant Builds",
    desc: "Legal basement specialists — drawings, permits, inspections and final sign-off handled.",
  },
  {
    icon: Clock,
    title: "On-Time, On-Budget",
    desc: "Transparent timelines, milestone updates and itemized quotes. No surprises.",
  },
  {
    icon: HardHat,
    title: "In-House Trades",
    desc: "Electrical, plumbing, carpentry and finishing — one accountable team, end to end.",
  },
  {
    icon: Award,
    title: "Considered Materials",
    desc: "We work with premium suppliers and never cut corners on what stays inside your walls.",
  },
  {
    icon: Users,
    title: "60% Referral Rate",
    desc: "From Etobicoke to Markham — past clients send us their friends. It's the metric we trust most.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      className="py-24 lg:py-36 bg-[#0B1B33] text-[#FAF7F2] relative overflow-hidden"
      data-testid="why-section"
    >
      <div className="absolute inset-0 grain pointer-events-none opacity-50" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#B08D5B]" />
              <span className="label-overline text-[10px] text-[#D4B888]">
                The Studio
              </span>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-[56px] tracking-tight font-light leading-[1.05]">
              Craftsmanship,
              <br />
              <span className="italic text-[#D4B888]">accountability</span>,
              <br />
              clean job sites.
            </h2>
            <p className="mt-8 font-body text-stone-300 leading-[1.85] text-[15px] max-w-md">
              We treat your home like it's our own. Every project — big or small — is led by a
              dedicated project manager so you always know what's happening, when.
            </p>
            <div className="mt-12 flex items-end gap-10 pt-10 border-t border-[#B08D5B]/30" data-testid="why-stats">
              {[
                { num: "12+", label: "Years Active" },
                { num: "500+", label: "Projects" },
                { num: "100%", label: "Insured" },
              ].map((s) => (
                <div key={s.label}>
                  <div className="font-heading text-4xl lg:text-5xl font-light text-[#D4B888]">
                    {s.num}
                  </div>
                  <div className="label-overline text-[9px] text-stone-400 mt-2">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#B08D5B]/15">
            {FEATURES.map((f, idx) => {
              const Icon = f.icon;
              return (
                <div
                  key={f.title}
                  className="bg-[#0B1B33] p-7 lg:p-8 transition-all duration-500 hover:bg-[#142847] group"
                  data-testid={`why-feature-${idx}`}
                >
                  <div className="w-11 h-11 border border-[#B08D5B]/40 text-[#D4B888] flex items-center justify-center mb-6 group-hover:border-[#D4B888] transition-colors duration-500">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-heading text-xl text-white mb-2 font-medium">
                    {f.title}
                  </h3>
                  <p className="text-stone-300 text-[14px] leading-[1.75] font-body">
                    {f.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
